import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddEducationFailure,
  AddEducationSuccess,
  EditEducationFailure,
  EditEducationSuccess,
} from '../../Redux/Actions/EducationAction';
import { ADD_EDUCATION, EDIT_EDUCATION } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddEducationEpic = action$ =>
  action$.pipe(
    ofType(ADD_EDUCATION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addEducation`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.educationmanagement, toast.success(response.response.message));
              return of(AddEducationSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              console.log(response.response);
              return of(AddEducationFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EditEducationEpic = action$ =>
  action$.pipe(
    ofType(EDIT_EDUCATION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editEducatin`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditEducationSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditEducationFailure(response.response));
            }
          }),
        ),
    ),
  );
